// @flow
import * as React from 'react';

import { BookUser, Globe } from 'lucide-react';
import { Tabs } from 'reshaped';

import { selectCanChooseResellee } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { selectCanChooseProductOwner } from 'src/Cart/AccountChoice/modules/selectors';
import { useAppSelector } from 'src/hooks/useAppSelector';

import type { Props } from '../../hooks/useModalType';

import { CustomerTab } from './CustomerTab';
import { ResellerOrganizationTab } from './ResellerOrganizationTab';

export function ResellerOwnerSelectModal(props: Props): React.MixedElement {
  const { __ } = useTranslator();

  const canChooseProductOwner = useAppSelector(selectCanChooseProductOwner);
  const canChooseResellee = useAppSelector(selectCanChooseResellee);

  return (
    // $FlowFixMe[incompatible-type] TabsUncontrolledProps
    <Tabs defaultValue={props.tabs}>
      <Tabs.List attributes={{ style: { marginBottom: 'var(--rs-unit-x1)' } }}>
        {canChooseResellee && (
          <Tabs.Item value="customers" icon={BookUser}>
            {__('My customers')}
          </Tabs.Item>
        )}
        {canChooseProductOwner && (
          <Tabs.Item value="organizations" icon={Globe}>
            {__('Other organizations')}
          </Tabs.Item>
        )}
      </Tabs.List>

      <Tabs.Panel value="customers" attributes={{ style: { height: '100%' } }}>
        <CustomerTab {...props} />
      </Tabs.Panel>
      {canChooseProductOwner && (
        <Tabs.Panel
          value="organizations"
          attributes={{ style: { height: '100%' } }}
        >
          <ResellerOrganizationTab {...props} />
        </Tabs.Panel>
      )}
    </Tabs>
  );
}
